import * as React from "react";

const ExpandUpIcon = (props) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 406 406" {...props}>
		<path d="M203.92 157.08c-10.66 11.78-21.11 23.31-31.54 34.86-36.44 40.32-72.89 80.63-109.31 120.96-7.23 8-15.92 13.3-26.76 14.42-20.85 2.16-35.29-16.02-29.75-37.26 1.78-6.85 5.12-12.84 9.83-18.06 52.68-58.31 105.2-116.78 158.16-174.84 18.12-19.87 41.82-19.05 59.16.14 52.16 57.71 104.28 115.46 156.42 173.18 5.93 6.56 10.04 13.97 11.55 22.82 3.67 21.44-13.68 37.93-34.86 33.01-9.15-2.12-16.47-7.15-22.69-14.06-19.16-21.29-38.38-42.52-57.57-63.77-26.51-29.36-53.02-58.73-79.53-88.09-.97-1.07-1.98-2.11-3.12-3.31Z" />
	</svg>
);

export default ExpandUpIcon;
